import { ContentPage } from '../page-factory/content-page';
import { basantPanchamiPage } from '../pages/page-kumbh-2025.basant-panchami';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(basantPanchamiPage);

export default function BasantPanchamiPage() {
  return <ContentPage {...basantPanchamiPage} />;
}
